import { Loading } from 'element-ui'

let loading

const start = () => {
  loading = Loading.service({
    lock: true,
    fullscreen: true,
    spinner: 'action-loader',
    background: 'rgba(0, 0, 0, 0.5)'
  })
}

const stop = () => {
  if (loading !== undefined) {
    loading.close()
  }
}

export default {
  methods: {
    startLoading: start,
    stopLoading: stop
  }
}
